import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import * as FPT from '../../utility/fpt';
import AppStore from '../../stores/AppStore';
import { withRouter } from 'react-router-dom';
import templateData, { localsMessages } from '../../utility/getTemplateData';
import { hideSpinnerOverlay } from '../../utility/helper';
import { hideLanguageSelector } from '../../utility/languageSelector';
import { Button } from '@paypalcorp/pp-react';
import Illustration from '../../components/illustrations/Illustration';
import ConfirmationTitle from '../../confirmation/ConfirmationTitle';
import ConfirmationBody from '../../confirmation/ConfirmationBody';
import { isMobileOrInContext } from '../../utility/inContextDonation';
import { isExternalFlow } from '../../utility/externalIntegrationUtils';
import CloseButton from '../../components/CloseButton';

class PaymentError extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount = () => {
    hideSpinnerOverlay();
    hideLanguageSelector();
    const ERROR_CODE = AppStore.getPaymentError() || '';
    FPT.trackPage(
      'main:donate:wps:guest:failure',
      'main:donate:wps:guest:failure:web::',
      'ERROR_CODE',
      ERROR_CODE
    );
  };

  handleTryAgain = () => {
    this.props.history.push(`/donate?token=${templateData.token}`);
  };

  render() {
    const { error = {}, label = {} } = localsMessages('errors/paymentError');
    const ERROR_CODE = AppStore.getPaymentError() || '';

    let { WSM_CANNOT_PAY_SELF = '', WENT_WRONG, TEMP_GLITCH } = error;
    let { tryagain } = label;

    switch (ERROR_CODE) {
      case 'WSM_PAYMENT_DENIED':
        WENT_WRONG = error.DID_NOT_WORK;
        TEMP_GLITCH = error.DIFF_CREDIT_DEBIT;
        tryagain = label.trydiffcard;
        break;
      case 'WSM_CANNOT_PAY_SELF':
        const L2 =
          WSM_CANNOT_PAY_SELF &&
          WSM_CANNOT_PAY_SELF.replace(
            '{data.dataMerchant.name}',
            templateData.donationName
          );
        WENT_WRONG = error.WSM_CANNOT_PAY_SELF_H;
        TEMP_GLITCH = L2;
        break;
      default:
        break;
    }

    return (
      <div>
        <div
          className={`donate_wrapper confirmation ${
            isMobileOrInContext() ? 'mobile_view' : ''
          }`}
        >
          {isExternalFlow() && <CloseButton />}
          <div className="ppvx_row">
            <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
              <Illustration type="warning" />
            </div>
          </div>
          <div className="ppvx_row">
            <div className="ppvx_col-12 text-center">
              <ConfirmationTitle message={WENT_WRONG} />
            </div>
          </div>
          <div className="ppvx_row">
            <div className="ppvx_col-12 text-center">
              <ConfirmationBody message={TEMP_GLITCH} />
            </div>
          </div>

          <div className="ppvx_row">
            <div className="ppvx_col-12 text-center">
              <Button
                className="btn-wide"
                id="tryAgain"
                onClick={this.handleTryAgain}
              >
                {tryagain}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(PaymentError);
